import Vue from 'vue'
import * as util from '../vendor/util'
import store from '../store/store'
import * as itemUtil from '../vendor/itemUtil'
import {hideCurrency} from "@/vendor/qconstants";
import {getLocalPrice} from "../vendor/util";

Vue.filter('pretty', function (jData) {
  if (!jData) {
    return '';
  }
  return JSON.stringify(jData, null, 2);
});

Vue.filter('noHtml', function (text) {
  if (!text) {
    return '';
  }
  return util.noHtml(text);
});

// Vue.filter('lengthString', function (data) {
//     if(!data){
//         return '';
//     }
//     try {
//         return JSON.stringify(data).length;
//     } catch (err) {
//         let d = '' + data;
//         return d.length;
//     }
// });

// Vue.filter('actionType', function (actionData) {
//     if(!actionData){
//         return;
//     }
//     if (actionData && actionData.type) {
//         return actionData.type;
//     }
//     return '';
// });

Vue.filter('stringList', function (items) {
  if (!items) {
    return;
  }
  return items.join(', ');
});


Vue.filter('uppercase', function (text) {
  return text.toUpperCase();
});

// Vue.filter('trim', function (text) {
//     return text.trim();
// });

Vue.filter('extrasList', function (extras, withoutSplit) {
  if (!extras) {
    return;
  }

  let result = '';
  let i = 0;
  for (let extra of extras) {
    i++;
    let displayPrice = '';
    if (extra.price > 0) {
      displayPrice = ' (' + util.getLocalPrice(extra.price) + ')';
    }
    let n = extra.name;
    if (withoutSplit) {
      n = util.withoutSplits(n);
    }
    result += n + displayPrice;
    if (i < extras.length) {
      result += ', ';
    }
  }

  return result;
});


Vue.filter('volPrefix', function (item) {
  if (!item) {
    return;
  }
  if (item.vol && item.vol.length > 0) {
    return item.vol + ' ';
  }
  return '';
});

Vue.filter('itemVol', function (orderItem) {
  if (!orderItem) {
    return;
  }
  let x = '';
  if (orderItem.vol && orderItem.vol.length > 0) {
    x = '(' + orderItem.vol + ')';
  }
  return x;
});

Vue.filter('displayDays', function (days) {
  //days = [ "1", "2", ...]
  if (!days) {
    return '';
  }
  let daysc = util.cloneMe(days);
  let sorted = daysc.sort((a, b) => a.localeCompare(b));
  let res = [];
  for (let d of sorted) {
    res.push(util.weekday[d]);
  }
  return res.join(', ');
});

Vue.filter('dateToString', function (createdAt) {
  if (!createdAt || createdAt === 0) {
    return '';
  }
  return util.getDateDisplay(createdAt);
});

Vue.filter('uhrzeit', function (utc) {
  if (!utc || utc === 0) {
    return '';
  }
  return util.getUhrzeit(utc);
});

Vue.filter('sdd', function (utc) {
  if (!utc || utc === 0) {
    return '';
  }
  return util.displayDayMonth(new Date(utc)) + ', ' + util.getUhrzeit(utc);
});


Vue.filter('iso8601ToMillis', function (iso) {
  if (!iso) {
    return '';
  }
  let date = new Date(iso);

  // Get the milliseconds since epoch (1. Jan. 1970)
  return date.getTime();
});


Vue.filter('priceTotal', function (number) {
  if (!number) {
    number = getLocalPrice(0, true);
  }
  let r = util.getLocalPrice(number);
  if (hideCurrency) {
    return util.noEuro(r);
  } else {
    return r;
  }
});

Vue.filter('price', function (number, noEuro) {
  if (!number || number === 0) {
    return '';
  }
  let r = util.getLocalPrice(number);
  if (noEuro || hideCurrency) {
    return util.noEuro(r);
  } else {
    return r;
  }
});

Vue.filter('displayOptionWithoutSplits', function (option) {
  if (option.labelDE.indexOf('|') > 0) {
    let splits = option.labelDE.split('|');
    return splits[0].trim();
  } else {
    return option.labelDE;
  }
});

Vue.filter('displayOptionPrice', function (_number, replaceArticle) {
  var number = parseFloat(_number);
  if (number === 0) {
    return ''
    // return '0,00 €'
  }
  if (replaceArticle) {
    return util.getLocalPrice(number);
  } else {
    if (number > 0) {
      return '+' + util.getLocalPrice(number);
    } else {
      return util.getLocalPrice(number);
      // return '-' + util.getLocalPrice(number);
    }
  }

});

Vue.filter('displayExtraPrice', function (extra, currentVol) {
  //note: extra is "style" in the json data model
  let result = '';
  let _cost = extra.cost;
  let number = 0;
  if (_cost) {
    number = parseFloat(_cost);
  }
  let displayPrice;
  if (number === 0) {
    displayPrice =  getLocalPrice(0, true);
  } else {
    displayPrice = util.getLocalPrice(number);
  }

  if ('volCosts' in extra && currentVol) {
    number = util.getExtraPrice(extra, currentVol);
    displayPrice = util.getLocalPrice(number);

    // let hasCurrent = currentVol && currentVol.length > 0;
    // for (let volCost of extra.volCosts) {
    //     if (hasCurrent) {
    //         if (volCost.volName === currentVol) {
    //             number = volCost.cost;
    //             displayPrice = util.getLocalPrice(number);
    //             // return util.getLocalPrice(volCost.cost);
    //             break;
    //         }
    //     } else {
    //         //display the first volCost
    //         number = volCost.cost;
    //         displayPrice = util.getLocalPrice(number);
    //         break;
    //     }
    //
    //     // ++i;
    //     // let lineBr = '';
    //     // if (i < extra.volCosts.length) {
    //     //     lineBr = '<br>'
    //     // }
    //     // result = result + volCost.volName + ': ' + util.getLocalPrice(volCost.cost) + lineBr;
    // }
  }

  if (number > 0) {
    result = '+ ' + displayPrice;
  } else if (number < 0) {
    result = '- ' + displayPrice;
  }
  return result;
});

Vue.filter('getOneSizeName', function (item) {
  let result = '';
  if ('sizes' in item) {
    if (item.sizes.length === 1) {
      result = item.sizes[0].vol;
    }
  }
  return result;
});


Vue.filter('weekDayMonth', function (createdAt, withYear) {
  if (!createdAt) {
    return '';
  }

  let dateObj = new Date(createdAt);
  let month = dateObj.getMonth() + 1; //months from 1-12
  let displayM = '' + month;
  if (month < 10) {
    displayM = '0' + month;
  }
  //FIXME must the createdAt argument be based on timezone ?
  let day = dateObj.getDate();
  let displayD = '' + day;
  if (day < 10) {
    displayD = '0' + day;
  }
  let wdi = util.getDayOfWeek(dateObj);
  let wd = util.weekday[wdi];
  let year = dateObj.getFullYear();
  let result = wd + ', ' + displayD + '.' + displayM;
  if (withYear) {
    result += '.' + year;
  }
  return result;
});

Vue.filter('camelCase', function (str) {
  if (!str) {
    return '';
  }
  return util.camelize(str)
});


// Vue.filter('tomorrow', function (openingHours) {
//     let nextDay = util.getNextDay();
//     let result = '';
//     try {
//         let oh = openingHours['' + nextDay];
//         if (oh.opened) {
//             result = '';
//             var hour = oh.a.fromHour;
//             if (hour < 10) {
//                 hour = '0' + oh.a.fromHour;
//             }
//             var minute = oh.a.fromMinute;
//             if (minute < 10) {
//                 minute = '0' + oh.a.fromMinute;
//             }
//             result +=
//                 util.displayOpeningHour(oh.a, 'from')
//                 + ' bis ' +
//                 util.displayOpeningHour(oh.a, 'till')+ ' Uhr';
//
//             var bhour = oh.b.fromHour;
//             if (bhour !== -1) {
//                 result +=
//                     ' und ' +
//                     util.displayOpeningHour(oh.b, 'from')
//                     + ' bis ' +
//                     util.displayOpeningHour(oh.b, 'till')+ ' Uhr';
//             }
//         }
//     } catch (e) {
//         console.log('Error in tomorrow: ' + e.message);
//     }
//     return result;
// });

Vue.filter('asClock', function (dayItem, fromOrTill) {
  if (!dayItem) {
    return '';
  }
  return util.displayOpeningHour(dayItem, fromOrTill);
});

Vue.filter('displayFiliale', function (filiale) {
  if (!filiale) {
    return '';
  }
  if (filiale.name) {
    return filiale.name + ', ' + filiale.strasse + ', ' + filiale.plz + ' ' + filiale.ort;
  } else {
    return filiale.strasse + ', ' + filiale.plz + ' ' + filiale.ort;
  }
});

Vue.filter('displayStoreShort', function (filiale) {
  if (!filiale) {
    return '';
  }
  return filiale.ort + ', ' + filiale.strasse;
});


Vue.filter('sizeDisplay', function (sizeObj) {
  var x = 'Standard';
  if (sizeObj.vol && sizeObj.vol.length > 0) {
    x = sizeObj.vol
  }
  return x;
});

Vue.filter('displayDeliveryAddressSingleLine', function (da) {
  if (!da) {
    return '';
  }
  let result = '';
  if (da.company) {
    result += da.company + ', ';
  }
  result += da.street + ', ' + da.plz + ' ' + da.city;
  if (da.etage) {
    result += ', ' + da.etage
  }
  return result;
});

Vue.filter('displayOrderUsecase', function (usecase) {
  if (!usecase) {
    return '';
  }

  let uc = usecase.toLowerCase();

  if (uc === 'takeaway') {
    return 'Abholung'
  } else if (uc === 'delivery') {
    return 'Lieferung'
  } else if (uc === 'selfservice') {
    return 'Selbstbedieung'
  } else if (uc === 'tableordering') {
    return 'Bestellung am Tisch'
  } else if (uc === 'inhouseMobilePayment') {
    return 'Inhouse Mobile Payment'
  }

  return uc;
});


Vue.filter('basePrice', function (item) {
  let offerAndItem = store.getters.getOfferByItemId(item.id);
  let rStep = itemUtil.findReplaceArticleStep(item);
  if (rStep) {
    //price of first option
    try {
      let lowestCost = 0;
      for (let o of rStep.options) {
        if (lowestCost === 0) {
          lowestCost = o.cost;
          continue
        }
        if (o.cost && o.cost < lowestCost) {
          lowestCost = o.cost;
        }
      }
      let c = lowestCost;
      let p = util.getLocalPrice(c);
      return 'ab ' + p;
    } catch (e) {
      return '';
    }
  } else if (item.extras && item.extras.combinations) {
    let smallestPrice = 9999;
    for (let combi of item.extras.combinations) {
      if (combi.price < smallestPrice) {
        smallestPrice = combi.price;
        combiId = combi.id;
      }
    }

    let ab = '';
    if (item.extras.combinations.length > 0) {
      ab = 'ab ';
    }

    if (offerAndItem) {
      if (offerAndItem.offer.type === 'discountOffer') {
        if (item.extras && item.extras.combinations) {
          for (let combi of item.extras.combinations) {
            if (combi.id === combiId) {
              let op = util.calcDiscount(combi, offerAndItem);
              return ab + util.getLocalPrice(op);
            }
          }
        }
      }
    }

    let r = ab + util.getLocalPrice(smallestPrice);
    return util.noEuro(r);
  } else {
    if (!item.sizes) {
      return '';
    }
    if (!item.sizes || item.sizes.length === 0) {
      return '';
    }

    let price = item.sizes[0].price;
    let basePrice = util.getLocalPrice(price);

    if (offerAndItem) {
      if (offerAndItem.offer.type === 'discountOffer') {
        let op = util.calcDiscount(item.sizes[0], offerAndItem);
        item.sizes[0].streichPreis = price;
        if (item.sizes.length > 1) {
          return ab + util.getLocalPrice(op);
        } else {
          return util.getLocalPrice(op);
        }
      }
    }

    // (item.extras && !util.isEmptyObject(item.extras) )
    if (item.sizes.length > 1) {
      basePrice = 'ab ' + basePrice;
    }
    return basePrice;
  }
});



